import React from "react";
import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { FeedbackFormPreview, FeedbackReviewPreview } from "./components";
import { QRProps } from "@/contexts/QREditorContext/types";
import { QRFeedbackProvider } from "@/contexts/QRFeedbackContext";
import { useFeedbackData } from "./hooks/useFeedbackData";
import "./FeedbackTemplate.scss";

export const FeedbackTemplate = (props: QRProps<"feedback">) => {
  const { data, isInitPreview, isEditor } = useFeedbackData(props);

  return (
    <PhoneLayout
      page="feedback"
      dataQA="preview-feedback-container"
      hasIncludeBrowser
      isInitPreview={isInitPreview}
    >
      <div className="feedback-template">
        <QRFeedbackProvider>
          {isInitPreview ? (
            /* vista del preview en el editor y sin empezar a rellenar el form*/
            <FeedbackFormPreview
              data={data}
              isInitPreview={isInitPreview}
              isEditor={isEditor}
            />
          ) : (
            /* vista del preview cuando se ha rellenado el form y en /p /qr*/
            <FeedbackReviewPreview
              data={data}
              isInitPreview={isInitPreview}
            />
          )}
        </QRFeedbackProvider>
      </div>
    </PhoneLayout>
  );
};

export default FeedbackTemplate;
